import { call, put, takeEvery, all, fork, takeLatest } from "redux-saga/effects";

// Crypto Redux States
import { Dashboard } from "./actiontype";
import { getMarketoverviewSuccess, getMarketoverviewFail, getWalletBalanceFail, getWalletBalanceSuccess, getInvestedOverviewSuccess, getInvestedOverviewFail, getDealerCountError, getDealerCountSuccess, getSupplierCountSuccess, getSupplierCountError, getFranchiseeCountSuccess, getFranchiseeCountError, getCustomerCountSuccess, getCustomerCountError, getJobsheetStatusSuccess, getJobsheetStatusError, getStockAdjustmentDashboardCountSuccess, getStockAdjustmentDashboardCountError, getJobsheetTrendSuccess, getJobsheetTrendError, getPurchaseOrderDashboardSuccess, getPurchaseOrderDashboardError, getJobsheetGraphDetailSuccess, getJobsheetGraphDetailError, getInvoiceCountSuccess, getInvoiceCountError, getReceivedPaymentError, getReceivedPaymentSuccess, getPendingPaymentSuccess, getPendingPaymentError, getFranchiseAppointmentDetailSuccess, getFranchiseAppointmentDetailError, getJobsheetTatSuccess, getJobsheetTatError, getPaymentStatusSuccess, getPaymentStatusError, getJobPrefixSuccess, getJobPrefixError } from "./actions";

//Include Both Helper File with needed methods
import {
  getMarketoverViewData, getWallentData, getInvestedData
} from "../../helpers/fakebackend_helper";
import { API } from "src/util/api";
import { getDealerContactSuccess } from "../dealer/actions";
import { cA } from "@fullcalendar/core/internal-common";
import { AxiosResponse } from "axios";

var res: Promise<any>

function* getChartsData({ payload: periodType }: any) {
  try {
    if (periodType == "ALL") {
      res = yield call(getMarketoverViewData, periodType);
    }
    if (periodType == "1M") {
      res = yield call(getMarketoverViewData, periodType);
    }
    if (periodType == "6M") {
      res = yield call(getMarketoverViewData, periodType);
    }
    if (periodType == "1Y") {
      res = yield call(getMarketoverViewData, periodType);
    }
    yield put(getMarketoverviewSuccess(Dashboard.GET_MARKET_OVERVIEW, res));
  } catch (error) {
    yield put(getMarketoverviewFail(Dashboard.GET_MARKET_OVERVIEW, error));
  }
}

var response: Promise<any>

function* getWalletBalance({ payload: data }: any) {
  try {
    if (data == "ALL") {
      response = yield call(getWallentData, data);
    }
    if (data == "6M") {
      response = yield call(getWallentData, data);
    }
    if (data == "1M") {
      response = yield call(getWallentData, data);
    }
    if (data == "1Y") {
      response = yield call(getWallentData, data);
    }
    yield put(getWalletBalanceSuccess(Dashboard.GET_WALLENT_BALANCE, response));
  }
  catch (error) {
    yield put(getWalletBalanceFail(Dashboard.GET_WALLENT_BALANCE, error));
  }
}
var investedData: Promise<any>

function* getInvestedOverviewData({ payload: data }: any) {
  try {
    if (data == "AP") {
      investedData = yield call(getInvestedData, data);
    }
    if (data == "MA") {
      investedData = yield call(getInvestedData, data);
    }
    if (data == "FE") {
      investedData = yield call(getInvestedData, data);
    }
    if (data == "JA") {
      investedData = yield call(getInvestedData, data);
    }
    if (data == "DE") {
      investedData = yield call(getInvestedData, data);
    }
    yield put(getInvestedOverviewSuccess(Dashboard.GET_Invested_Overview, investedData));
  }
  catch (error) {
    yield put(getInvestedOverviewFail(Dashboard.GET_Invested_Overview, error));
  }
}

function* getDealerCountAsync() {
  try {
    const response: Promise<any> = yield call(API.fetchDealerCountApi)
    yield put(getDealerCountSuccess(response));
  } catch (error) {
    yield put(getDealerCountError(error));
  }
}

function* getSupplierCountAsync() {
  try {
    const response: Promise<any> = yield call(API.fetchSupplierCountApi)
    yield put(getSupplierCountSuccess(response));
  } catch (error) {
    yield put(getSupplierCountError(error));
  }
}

function* getFranchiseeCountAsync() {
  try {
    const response: Promise<any> = yield call(API.fetchFranchiseeCountApi)
    yield put(getFranchiseeCountSuccess(response));
  } catch (error) {
    yield put(getFranchiseeCountError(error));
  }
}

function* getCustomerCountAsync() {
  try {
    const response: Promise<any> = yield call(API.fetchCustomerCountApi)
    yield put(getCustomerCountSuccess(response));
  } catch (error) {
    yield put(getCustomerCountError(error));
  }
}

function* getJobsheetStatusCountAsync(payload: any) {

  try {
    const response: Promise<any> = yield call(API.fetchJobsheetStatusCountApi, payload)
    yield put(getJobsheetStatusSuccess(response));
  } catch (error) {
    yield put(getJobsheetStatusError(error));
  }
}

//get stock adjustment dashboard count

function* getStockAdjusmentCountAsync(payload: any) {
  
  try {
    const response: Promise<any> = yield call(API.fetchstockAdjustmentCountApi, payload);
    yield put(getStockAdjustmentDashboardCountSuccess(response));
  } catch (error) {
    yield put(getStockAdjustmentDashboardCountError(error));
  }
}

function* getJobsheetTrendCountAsync(payload: any) {
  
  try {
    const response: Promise<any> = yield call(API.fetchJobsheetTrendCountApi, payload)
    yield put(getJobsheetTrendSuccess(response));
  } catch (error) {
    yield put(getJobsheetTrendError(error));
  }
}

function* PurchaseOrderDashboardDetailAsync(payload: any) {
  try {
    const response: Promise<any> = yield call(API.fetchPurchaseOrderDashboardApi, payload)
    yield put(getPurchaseOrderDashboardSuccess(response));
  } catch (error) {
    yield put(getPurchaseOrderDashboardError(error));
  }
}

function* JobsheetGraphDetailAsync(action:any) {
  try {
    const response: Promise<any> = yield call(API.fetchJobsheetGraphDetailApi,action.payload)
    yield put(getJobsheetGraphDetailSuccess(response));
  } catch (error) {
    yield put(getJobsheetGraphDetailError(error));
  }
}

function* getInvoiceCountAsync(action:any){
  
  try {
    const response : Promise<any> = yield call(API.getInvoiceCountApi,action.payload);
    yield put(getInvoiceCountSuccess(response));
  } catch (error) {
    yield put(getInvoiceCountError(error))
  }
}

function* getReceivedPaymentCountAsync(action:any){
  try {
    const response : Promise<any> = yield call(API.getReceivedpaymentCountApi,action.payload);
    yield put(getReceivedPaymentSuccess(response));
  } catch (error) {
    yield put(getReceivedPaymentError(error))
  }
}


function* getPendingPaymentCountAsync(action:any){
  try {
    const response : Promise<any> =  yield call(API.getPendingpaymentCountApi,action.payload);
    yield put(getPendingPaymentSuccess(response));
  } catch (error) {
    yield put(getPendingPaymentError(error))
  }
}

// function* getFranchiseAppointmentDetailAsync(action:any){
//   try {
//     const [response1, response2, response3,response4,response5] : any[] =  yield all([
//       call(API.getFranchiseAppointmentDetailApi,action.payload),
//       call(API.getFranchiseLiveDetailApi,action.payload),
//       call(API.getFranchiseCompletedDetailApi,action.payload),
//       call(API.getFranchiseWithoutAppointmentDetailApi,action.payload),
//       call(API.getFranchiseAppointmentDetailApi,action.newLazyState),
//     ]);
//     debugger
//     let resp = {
//       totalCount:0,
//       items:[
//         ...response1?.data?.items,
//         ...response2?.data?.items,
//         ...response3?.data?.items,
//         ...response4?.data?.items,
//       ],
//       NotScheduled:response5?.data?.items?.filter((data:any)=>data.className == "NotScheduled")
//     }
//     yield put(getFranchiseAppointmentDetailSuccess(resp));
//   } catch (error) {
//     yield put(getFranchiseAppointmentDetailError(error))
//   }
// }
function* getFranchiseAppointmentDetailAsync(action: any) {
  try {
    const responses = [
      API.getFranchiseAppointmentDetailApi,
      API.getFranchiseLiveDetailApi,
      API.getFranchiseCompletedDetailApi,
      API.getFranchiseWithoutAppointmentDetailApi,
    ];

    // We'll store items cumulatively
    let allItems: any[] = [];
    let notScheduledItems: any[] = [];

    for (let i = 0; i < responses.length; i++) {
      const apiCall = responses[i];
      try {
        const res: AxiosResponse<any> = yield call(apiCall, action.payload);
        if (res?.data?.items?.length) {
          allItems = [...allItems, ...res.data.items];

          // Dispatch success incrementally
          yield put(
            getFranchiseAppointmentDetailSuccess({
              totalCount: allItems.length,
              items: allItems,
              NotScheduled: notScheduledItems,
            })
          );
        }
      } catch (err) {
        // Optionally handle individual API errors without stopping others
        console.error(`API ${i} failed`, err);
      }
    }

    // Handle the "NotScheduled" API separately if needed
    if (action.newLazyState) {
      try {
        const res5: AxiosResponse<any> = yield call(
          API.getFranchiseAppointmentDetailApi,
          action.newLazyState
        );
        if (res5?.data?.items?.length) {
          notScheduledItems = res5.data.items.filter(
            (item: any) => item.className === 'NotScheduled'
          );

          // Dispatch updated state including NotScheduled
          yield put(
            getFranchiseAppointmentDetailSuccess({
              totalCount: allItems.length,
              items: allItems,
              NotScheduled: notScheduledItems,
            })
          );
        }
      } catch (err) {
        console.error('NotScheduled API failed', err);
      }
    }
  } catch (error) {
    yield put(getFranchiseAppointmentDetailError(error));
  }
}

function* getJobsheetTatAsync(action:any){
  try {
    const response : Promise<any> = yield call(API.getJobsheetTatApi,action.payload);
    yield put(getJobsheetTatSuccess(response));
  } catch (error) {
    yield put(getJobsheetTatError(error))
  }
}

function* getInvoiceStatusAsync(action:any){
  try {
    let purchaseOrderData = {
      ...action.payload,
      filters:{
        PurchaseStartDate:{value:action.payload.filters.InvoiceCreationStartDate?.value},
        PurchaseEndDate:{value:action.payload.filters.InvoiceCreationEndDate?.value},
      }
    }
    const [response1, response2] : any[] =  yield all([
      call(API.getPaymentStatusApi,action.payload),
      call(API.getDealerPaymentStatusApi,purchaseOrderData),
    ]);
    let data = {
      items:response1?.data?.items,
      purchaseValue:response2?.data
    }
    debugger
    yield put(getPaymentStatusSuccess(data));
  } catch (error) {
    yield put(getPaymentStatusError(error))
  }
}

function* getJobPrefixAsync(action:any){
  try {
    const response : Promise<any> = yield call(API.getJobPrefixforManufacturer);
    yield put(getJobPrefixSuccess(response));
  } catch (error) {
    yield put(getJobPrefixError(error))
  }
}

export function* watchGetChartsData() {
  yield takeEvery(Dashboard.GET_MARKET_OVERVIEW, getChartsData);
  yield takeEvery(Dashboard.GET_WALLENT_BALANCE, getWalletBalance);
  yield takeEvery(Dashboard.GET_Invested_Overview, getInvestedOverviewData);
  yield takeLatest(Dashboard.GET_DEALER_COUNT, getDealerCountAsync);
  yield takeLatest(Dashboard.GET_SUPPLIER_COUNT, getSupplierCountAsync);
  yield takeLatest(Dashboard.GET_FRANCHISEE_COUNT, getFranchiseeCountAsync);
  yield takeLatest(Dashboard.GET_CUSTOMER_COUNT, getCustomerCountAsync);
  yield takeLatest(Dashboard.GET_JOBSHEET_STATUS_COUNT, getJobsheetStatusCountAsync);
  yield takeLatest(Dashboard.GET_STOCK_ADJUSTMENT_DASHBOARD_DETAILS_LOADING, getStockAdjusmentCountAsync)
  yield takeLatest(Dashboard.GET_JOBSHEET_TREND_COUNT, getJobsheetTrendCountAsync);
  yield takeLatest(Dashboard.GET_PURCHASE_ORDER_DASHBOARD_DETAILS_LOADING, PurchaseOrderDashboardDetailAsync);
  yield takeLatest(Dashboard.GET_JOBSHEET_GRAPH_DASHBOARD_DETAILS_LOADING, JobsheetGraphDetailAsync);
  yield takeLatest(Dashboard.GET_INVOICE_COUNT_DASHBOARD_LOADING,getInvoiceCountAsync);
  yield takeLatest(Dashboard.GET_RECEIVED_PAYMENT_COUNT_LOADING,getReceivedPaymentCountAsync);
  yield takeLatest(Dashboard.GET_PENDINGPAYMENT_COUNT_LOADING,getPendingPaymentCountAsync);
  yield takeLatest(Dashboard.GET_FRANCHISE_APPOINTMENT_DETAIL_LOADING,getFranchiseAppointmentDetailAsync);
  yield takeLatest(Dashboard.GET_JOBSHEET_TAT_LOADING,getJobsheetTatAsync);
  yield takeLatest(Dashboard.GET_PAYMENT_STATUS_LOADING,getInvoiceStatusAsync);
  yield takeLatest(Dashboard.GET_JOB_PREFIX_LOADING,getJobPrefixAsync);
}

function* dashboardSaga() {
  yield all([fork(watchGetChartsData)]);
}

export default dashboardSaga;
